import { useQuery } from '@tanstack/react-query';
import { ApiError, type RoleAssignmentsResponse } from '@citibox-panel/api-client';

// The one key for the list: the write invalidates it and the route drops it on a denial.
export const ROLE_ASSIGNMENTS_KEY = ['role-assignments'] as const;

const isClientError = (error: unknown): boolean =>
  error instanceof ApiError && error.status >= 400 && error.status < 500;

// staleTime 0: another person of Sistemas may have changed the list, so every visit reads it again.
// networkMode 'always': offline is a failure with «Reintentar», never a paused, endless loading.
// A 4xx is the server's answer (the 403 above all) and is not asked again; a network failure or a
// 5xx gets one more try. `enabled` lets the route stop reading once access is denied.
export function useRoleAssignments(
  fetchRoleAssignments: () => Promise<RoleAssignmentsResponse>,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ROLE_ASSIGNMENTS_KEY,
    queryFn: () => fetchRoleAssignments(),
    enabled,
    staleTime: 0,
    networkMode: 'always',
    retry: (failureCount, error) => !isClientError(error) && failureCount < 1,
  });
}
